import React from 'react';
export function Footer() {
  return <footer className="bg-brown text-white/70 py-12" data-id="element-40">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-41">
        <div className="text-xl font-serif font-medium text-white" data-id="element-42">
          Método Piel Clara Natural
        </div>
        <div className="text-sm font-light" data-id="element-43">
          &copy; {new Date().getFullYear()} Todos los derechos reservados.
        </div>
      </div>
    </footer>;
}